var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 49,
    viewBox: "0 0 41 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6342 1.06848H7.63044C4.39173 1.06848 1.76624 4.2653 1.76624 8.20877V39.8711C1.76624 43.8145 4.39173 47.0113 7.63044 47.0113H33.6342C36.8729 47.0113 39.4984 43.8145 39.4984 39.8711V8.20877C39.4984 4.2653 36.8729 1.06848 33.6342 1.06848Z",
    stroke: "#19292C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1151 32.2808C11.0886 30.0411 10.4165 26.1695 10.9511 22.1399C11.5799 17.4164 14.9994 13.9467 18.6469 12.6211C20.3251 12.0085 22.0821 11.731 23.8272 11.597C24.9277 11.5108 26.0282 11.4917 27.1327 11.5108C28.3472 11.53 29.5499 11.7405 30.7604 11.7788C30.843 11.7788 30.8823 11.8937 30.8273 11.9702C29.4516 13.8606 28.8817 16.2487 28.7834 18.766C28.6302 22.8099 28.4729 27.6578 26.0714 30.7781C23.6149 33.9702 19.8496 34.2286 16.4812 33.8601",
    stroke: "#19292C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1598 37.6501C13.1598 37.6501 13.3799 27.5139 22.6793 17.8707",
    stroke: "#19292C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.9e8467cf7d43aff3589c649dddfd9ed4.svg";
export { ForwardRef as ReactComponent };